const determineImgSrcFromList = (title, imgUrls) =>
{
    const numberForHash = title ? title.length : 20;
    const titleHash = numberForHash % (imgUrls.length - 1);

    return imgUrls[titleHash] || imgUrls[3];
};

export default determineImgSrcFromList;
